import React, { useState } from "react";
import { Grid, Select, MenuItem, Input } from "@material-ui/core";
import { ArrowForward as ArrowForwardIcon, MoreVert, Notifications as NotificationsIcon } from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Widget from "../../../../components/Widget/Widget";
import { Typography } from "../../../../components/Wrappers/Wrappers";
import { Row } from "reactstrap";

export default function BigStat(props) {
  var { product, total, color, registrations, graphData, value_d, bounce, date, total_risk, High_Risks, Medium_Risks } = props;
  var classes = useStyles();
  var theme = useTheme();

  const des = JSON.parse(localStorage.getItem('holder'))
  console.log(des, "Bigstatet")
  // local
  var [value, setValue] = useState("daily");

  return (
    <Widget
    noBodyPadding
      header={
        <div className={classes.title}>
          <div style={{  fontSize: "30px",  color: "#101828", fontWeight: "bold", lineHeight: "1" }} >
            {value_d}
          </div>
          <div style={{display:"flex", justifyContent: "space-between", width: "100%"}} >
              <span className="mb-0" title={des[product]} style={{ cursor: "help", fontSize: "24px", textTransform: "capitalize", color: "black", lineHeight: "1" }}> <b title={des[product]} >{product}</b></span>
              <span style={{ marginRight: "0px", float: "right", cursor: "help", color: "black" }}><i title={des[product]} style={{ cursor: "help", "font-size": "20px", color: "black" }}  aria-hidden="true"><MoreVert/></i></span>

          </div>
         
          {/* <Typography variant="h5">{product}</Typography> */}
          {/* <NotificationsIcon /> */}
          {/* <Select
            value={value}
            onChange={e => setValue(e.target.value)}
            input={
              <Input
                disableUnderline
                classes={{ input: classes.selectInput }}
              />
            }
            className={classes.select}
          >
            <MenuItem value="daily">{date}</MenuItem>
          </Select> */}
        </div>
      }
      upperTitle
    >



      <div className={classes.totalValueContainer} >
       
        <ResponsiveContainer width="100%" height={150}>

          <BarChart data={graphData}>
            <Bar
              dataKey="value"
              fill={theme.palette[color].main}
              radius={5}
              barSize={15}
            />
            <YAxis axisLine={false} style={{
              fontSize: '7px',
              fontFamily: 'Times New Roman',
            }} />
            <XAxis dataKey="date" axisLine={false} style={{
              fontSize: '10px',
              fontFamily: 'Times New Roman',
            }} />
            <CartesianGrid stroke="#EAECF0" strokeDasharray="5 5"/>

          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className={classes.bottomStatsContainer}>
        <div className={classnames(classes.statCell, classes.borderRight)}>
          <Grid container alignItems="center" className={classes.gridCenter}>
            {/* <Typography variant="h6">{total_risk}</Typography> */}
            {/* <ArrowForwardIcon
              className={classnames(classes.profitArrow, {
                [!registrations[value].profit]: classes.profitArrowDanger,
              })}
            /> */}
          </Grid>
          {/* <Typography size="sm" color="text" colorBrightness="secondary">
            Total Risks
          </Typography> */}
        </div>
        <div className={classes.statCell}>
          <Grid container alignItems="center" className={classes.gridCenter}>
            {/* <Typography variant="h6">{High_Risks}</Typography> */}
            {/* <ArrowForwardIcon
              className={classnames(classes.profitArrow, {
                [!registrations[value].profit]: classes.profitArrowDanger,
              })}
            /> */}
          </Grid>
          {/* <Typography size="sm" color="text" colorBrightness="secondary">
            High Risks
          </Typography> */}
        </div>
        <div className={classnames(classes.statCell, classes.borderRight)}>
          <Grid container alignItems="center" className={classes.gridCenter}>
            {/* <Typography variant="h6">
              {Medium_Risks}
            </Typography> */}
            {/* <ArrowForwardIcon
              className={classnames(classes.profitArrow, {
                [classes.profitArrowDanger]: !registrations[value].profit,
              })}
            /> */}
          </Grid>
          {/* <Typography size="sm" color="text" colorBrightness="secondary">
          Medium Risks
          </Typography> */}
        </div>
      </div>
    </Widget>
  );
}

// #######################################################################

function getRandomData() {
  return Array(7)
    .fill()
    .map(() => ({ value: Math.floor(Math.random() * 10) + 1 }));
}
